import * as ActionTypes from "../ActionTypes";
import * as URL from "../API_URL";
import {
//   getRequest,
  postRequest,
//   getRequest1,
//   getRequest2,
//   postRequest1,
//   postRequest2,
//   postRequest3,
//   postRequest4,
//   uploadPostRequest,
//   fetchcampaign,
} from "./index";
export const getVerdaPdf = (data) => {
    return postRequest(URL.VERDA_CARE_ENROLL_PDF, data, ActionTypes.VERDA_CARE_ENROLL_PDF);
  };